import { Box } from "@mui/material";
import styled from "styled-components";

export const CompanyInfoFormStyled = styled(Box)`
  .creation-template {
    margin: 16px 0;
  }
  .detail-template {
    display: grid;
    grid-template-columns: 60% calc(40% - 16px);
    gap: 16px;
  }
  .flex {
    display: flex;
    gap: 8px;
    padding: 8px 0;
    align-items: baseline;
  }

  .grid-3 {
    display: grid;
    grid-template-columns: 1fr 0.5fr 0.5fr;
    gap: 8px;
    padding: 8px 0;
    align-items: baseline;
  }
  .flex-block {
    display: flex;
    flex-direction: column;
  }

  .hr {
    border-bottom: 1px solid #dedafb !important;
    border: none;
    margin: 8px 0px;
  }
`;
